import { Theme, Popover } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';

const StyledPopover = withStyles((theme: Theme) => ({
  paper: {
    backgroundColor: '#0B1017',
    borderStyle: 'solid',
    borderWidth: '1px',
    borderImageSource: 'linear-gradient(253deg, #d51bff, #558afe)',
    borderImageSlice: '1',
    backgroundImage: 'linear-gradient(to bottom, #0e1319, #0e1319), linear-gradient(253deg, #d51bff, #558afe)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '8px !important',
  },
}))(Popover);

export default StyledPopover;
